import { Component, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import {ApiService} from '../shared/api.service';
import { Utils } from '../utils';

@Pipe({name: 'blacklistFilter', pure: false})
export class BlacklistFilterPipe implements PipeTransform {
    transform(list, text): string {
        if( !text ) {
            return list;
        }
        text = text.toLocaleLowerCase().trim();
        return list.filter(item => {
            item = item.toLocaleLowerCase();
            return item.indexOf(text) !== -1;
        });
    }
}
@Component({
    selector: 'banned-words',
    templateUrl: 'banned-words.component.html'
})
export class BannedWordsComponent implements OnDestroy {
    searchText = '';
    canEdit = false;
    blacklistObj = {};
    blacklistKeys = [];
    blacklistEditor = '';
    error = '';
    heartbeatSubscription;
    loading = false;
    saved = false;
    newTerm = '';

    constructor(public api: ApiService, public utils: Utils) {
        const user = this.api.getProp('user');
        if( user.role == 'administrator' || user.role == 'editor' ) {
            this.canEdit = true;
        }
        this.setup();
        if( this.canEdit ) {
            this.checkLock(false);
            this.heartbeatSubscription = this.api.heartbeat.subscribe(() => {
                this.checkLock(false);
            });
        }
    }
    setup() {
        const blacklist = this.api.getProp('blacklist');
        const blacklistObj = {};
        for(var i = 0; i < blacklist.length; i++) {
            const first = blacklist[i].charAt(0).toLocaleLowerCase();
            if( !blacklistObj[first] ) {
                blacklistObj[first] = [];
            }
            blacklistObj[first].push(blacklist[i]);
        }
        this.blacklistObj = blacklistObj;
        this.blacklistKeys = Object.keys(blacklistObj);
    }
    checkLock(takeover) {
        this.api.doAction('post', 'censorship', {
            action: 'check_lock'
        }).subscribe(
            data => {
                if( data.locked && !takeover ) {
                    this.blacklistEditor = data.blacklistEditor;
                }
                if( takeover || !data.locked ) {
                    this.setLock('update');
                }
            },
            err => {
                this.error = err.error.message;
                throw err;
            }
        );
    }
    setLock(action) {
        this.resetError();
        this.loading = true;
        this.api.doAction('post', 'censorship', {
            action: 'set_lock',
            lockAction: action
        }).subscribe(
            data => {
                if( action == 'update' ) {
                    this.blacklistEditor = '';
                }
            },
            err => {
                this.error = err.error.message;
                throw err;
            }
        ).add(() => {
            this.loading = false;
        });
    }
    triggerSaveMessage() {
        this.saved = true;
        setTimeout(() => {
            this.saved = false;
        }, 3000);
    }
    hasTerm() {
        const blacklist = this.api.getProp('blacklist');
        return blacklist.filter(item => {
            return item.toLocaleLowerCase() == this.searchText.toLocaleLowerCase();
        }).length > 0;
    }
    addTerm() {
        this.error = '';
        this.searchText = this.searchText.trim();
        if( !this.searchText || !this.canEdit || this.blacklistEditor ) {
            return;
        }
        if( this.hasTerm() ) {
            this.error = 'Term already exists';
            return;
        }
        this.loading = true;
        this.api.doAction('post', 'censorship', {
            action: 'add',
            term: this.searchText
        }).subscribe(
            data => {
                if( data.blacklistEditor ) {
                    this.blacklistEditor = data.blacklistEditor;
                    return;
                }
                const blacklist = this.api.getProp('blacklist');
                blacklist.push(data.newTerm);
                blacklist.sort((a, b) => {
                    return a.toLocaleLowerCase() > b.toLocaleLowerCase() ? 1 : -1;
                });
                this.setup();
                this.searchText = '';
                this.triggerSaveMessage();
            },
            err => {
                this.error = err.error.message;
                throw err;
            }
        ).add(() => {
            this.loading = false;
        });
    }
    removeTerm(term) {
        this.error = '';
        this.loading = true;
        this.api.doAction('post', 'censorship', {
            action: 'delete',
            term: term
        }).subscribe(
            data => {
                if( data.blacklistEditor ) {
                    this.blacklistEditor = data.blacklistEditor;
                    return;
                }
                const blacklist = this.api.getProp('blacklist');
                let i = blacklist.length;
                while(i--) {
                    if( blacklist[i].toLocaleLowerCase() == term.toLocaleLowerCase() ) {
                        blacklist.splice(i, 1);
                    }
                }
                this.setup();
                this.triggerSaveMessage();
            },
            err => {
                this.error = err.error.message;
                throw err;
            }
        ).add(() => {
            this.loading = false;
        });
    }
    resetError() {
        this.error = '';
    }
    ngOnDestroy() {
        this.setLock('delete');
        if( this.heartbeatSubscription ) {
            this.heartbeatSubscription.unsubscribe();
        }
    }
}